// extracted by mini-css-extract-plugin
export default {"Dashboard":"style_Dashboard__4ZQ8a","dashboardFadeIn":"style_dashboardFadeIn__opRQp","MiddleRow":"style_MiddleRow__Aabyo"};